import { render } from "./LearningLanguageSwitcher.vue?vue&type=template&id=788b399f&scoped=true"
import script from "./LearningLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LearningLanguageSwitcher.vue?vue&type=script&lang=js"

import "./LearningLanguageSwitcher.vue?vue&type=style&index=0&id=788b399f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788b399f"]])

export default __exports__